import React from 'react';
import styles from './index.module.scss'

class ProgressStepBarCupra extends React.Component {

  getStepStyle = (paso) => {
    let style = ''
    let actual = this.props.pasos.estatusActual

    if (paso.idHistorialEstatus <= actual.idHistorialEstatus) {

      if (actual.resultado === "Perdida") {
        style = styles.error
      } else {
        style = styles.ok
      }
    }
    return style
  }

  getStepDate = (paso) => {
    let date = new Date(paso.fechaModificacion);
    const dateTimeFormat = new Intl.DateTimeFormat('ex-MX', { year: 'numeric', month: '2-digit', day: '2-digit' })
    const [{ value: month }, , { value: day }, , { value: year }] = dateTimeFormat.formatToParts(date);
    return `${month}/${day}/${year}`
  }

  getLastStepMargin = (i, array) => {

    let mt = ""

    //esta en el penultimo paso, dale el estilo para mobile
    if(i === (array.length - 1)) {
      if(array[array.length - 2]?.fechaModificacion !== null) {
        mt = "mt-3 mt-sm-0"
      }
    }

    return mt
  }

  render() {

    let arreglo = Array.from(this.props.pasos.otrosEstatus);
    arreglo.push(this.props.pasos.estatusActual);
    arreglo.sort(function (a, b) {
      return a.orden - b.orden;
    });
    if (arreglo.filter(t => t.actividad === "Venta de contado").length) {
      arreglo = arreglo.filter(t => t.nombreEstatus !== "Solicitud de crédito" && t.nombreEstatus !== "Autorización de crédito" && t.nombreEstatus !== "Pago de enganche");
    }

    return (
      <div className={styles.cupra}>
        <div className={styles.component_frame}>
          {
            arreglo.map((paso, i, arr) => {

              return (
                <div className={`${styles.step} ${this.getLastStepMargin(i, arr)}`} key={i}>
                  <div>
                    {
                      this.getStepStyle(paso) !== '' ?

                        <div className={`${styles.circle + ' ' + styles.full} ${this.getStepStyle(paso)}'`}>
                          <div className={`${this.getStepStyle(paso)}`} />
                        </div>

                        :

                        <div className={`${styles.circle + ' ' + styles.extra_ml}`}>
                          <div className={``} />
                        </div>
                    }


                  </div>
                  <div>
                    <div className={'d-flex justify-content-start align-items-center align-items-baseline'}>
                      <div className={`${styles.title} ${styles.dateSpace} ${paso.fechaModificacion === null ? styles.gray : ''}`}>
                        {`${paso.fechaModificacion ? this.getStepDate(paso) : "--/--/----"}`}
                      </div>
                      <div className={`${styles.title} ${paso.fechaModificacion === null ? styles.gray : styles.line}`}>&nbsp;{'|'}&nbsp;</div>
                      <div className={`${styles.title} ${paso.fechaModificacion === null ? styles.gray : ''}`}>{`${paso.nombreEstatus}`}</div>
                    </div>
                    <label className={`${styles.message} ${(paso.mensajeFuente !== "" && paso.fechaModificacion !== null) ? 'visible' : 'invisible'}`}>{paso.mensajeFuente}</label>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

}

export default ProgressStepBarCupra
